import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const pagosProveedores = (query) => http.get(`${api}/pagos-proveedores`, { params: { ...query } })

export {
  pagosProveedores
}
